module.exports = __webpack_public_path__ + "img/duels.4b4c3aa6.webp";